import React from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';

interface PaginationProps {
  pagination: any;
  pageConfig: any;
  setPageConfig: any;
}

const PaginationCustom: React.FC<PaginationProps> = ({ pagination, pageConfig, setPageConfig }) => {
  const getPage = () => pagination?.pageable.pageNumber + 1;
  const getLimit = () => pagination?.pageable.pageSize;
  const getTotal = () => pagination?.totalElements;
  const totalPages = pagination?.totalPages;

  const renderPageNumbers = () => {
    const currentPage = pagination?.pageable.pageNumber;
    const pageNumbers = [];

    for (let i = 0; i < totalPages; i++) {
      if (
        i === 0 ||
        i === totalPages - 1 ||
        (i >= currentPage - 2 && i <= currentPage + 2)
      ) {
        pageNumbers.push(
          <a
            key={i}
            href="#"
            className={`relative inline-flex items-center px-4 py-2 text-sm font-semibold ${
              i === currentPage ? 'bg-yellow-400 text-black' : 'text-gray-900 ring-1 ring-gray-300 ring-inset hover:bg-gray-50'
            } focus:z-20 focus:outline-offset-0`}
            onClick={() => setPageConfig((prev: any) => ({ ...prev, page: i }))}
          >
            {i + 1}
          </a>
        );
      } else if (
        (i === currentPage - 3 && currentPage > 3) ||
        (i === currentPage + 3 && currentPage < totalPages - 4)
      ) {
        pageNumbers.push(
          <span
            key={i}
            className="relative inline-flex items-center px-4 py-2 text-sm font-semibold text-gray-700 ring-1 ring-gray-300 ring-inset focus:outline-offset-0"
          >
            ...
          </span>
        );
      }
    }

    return pageNumbers;
  };

  return (
    <div className="flex flex-row items-center justify-between gap-4 mx-4 mt-5">
      <div className="flex flex-row items-center gap-2 ">
        <select
          onChange={e => {
            setPageConfig({
              ...pageConfig,
              ...{ limit: Number(e.target.value), page: 0 },
            });
          }}
          className="w-full p-2 pr-10 text-xs bg-gray-100 border border-gray-100 rounded alurkerja-form"
          style={{ paddingRight: '30px' }}
        >
          <option value={10}>10</option>
          <option value={15}>15</option>
          <option value={20}>20</option>
          <option value={25}>25</option>
          <option value={30}>30</option>
        </select>
        <span className="whitespace-nowrap text-xs text-[#5E6278]">
          {`Displaying data from ${getPage()} to ${getLimit()} total of ${getTotal()}`}
        </span>
      </div>

      <div>
        <nav aria-label="Pagination" className="isolate inline-flex -space-x-px rounded-md shadow-xs">
          <a
            href="#"
            className="relative inline-flex items-center rounded-l-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
            onClick={() => setPageConfig((prev: any) => ({ ...prev, page: Math.max(prev.page - 1, 0) }))}
          >
            <span className="sr-only">Previous</span>
            <ChevronLeftIcon aria-hidden="true" className="size-5" />
          </a>
          {renderPageNumbers()}
          <a
            href="#"
            className="relative inline-flex items-center rounded-r-md px-2 py-2 text-gray-400 ring-1 ring-gray-300 ring-inset hover:bg-gray-50 focus:z-20 focus:outline-offset-0"
            onClick={() => setPageConfig((prev: any) => ({ ...prev, page: Math.min(prev.page + 1, totalPages - 1) }))}
          >
            <span className="sr-only">Next</span>
            <ChevronRightIcon aria-hidden="true" className="size-5" />
          </a>
        </nav>
      </div>
    </div>
  );
};

export default PaginationCustom;